import { render, staticRenderFns } from "./FormCodeConfig.vue?vue&type=template&id=5f117984&scoped=true"
import script from "./FormCodeConfig.vue?vue&type=script&lang=js"
export * from "./FormCodeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f117984",
  null
  
)

export default component.exports